module.exports = __webpack_public_path__ + "static/img/home_adv_photo2@2x.4143407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourAdvantage/home_adv_photo2@2x.png
// module id = QL8l
// module chunks = 0